module.exports = __webpack_public_path__ + "img/008.f854d88c.png";